module.exports = __webpack_public_path__ + "img/阴险.f918b832.gif";